import React from "react";

const Circle = () => {
  return (
    <svg viewBox="0 0 215 216">
      <path fill="#5B7E96" d="M107.5 215.6c59.371 0 107.5-48.13 107.5-107.5C215 48.729 166.871.599609 107.5.599609 48.1294.599609 0 48.729 0 108.1c0 59.37 48.1294 107.5 107.5 107.5Z"/>
    </svg>
  )
}

export default Circle
